import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.7965 3.61043L12.3823 2.1958L7.99817 6.58122L3.61416 2.19592L2.19995 3.61055L6.58396 7.99585L2.19996 12.3812L3.61417 13.7958L7.99817 9.41049L12.3823 13.7959L13.7965 12.3813L9.41238 7.99585L13.7965 3.61043Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgCrossSmall);
export { ForwardRef as ReactComponent };
